// @flow
export const listReducer = (setListAction: string) => (state: any[] = [], action: Object) => {
  switch (action.type) {
    case setListAction:
      return [...action.payload];
    default:
      return state;
  }
};